<template>
  <PostBase
  :isShareSpace = "isShareSpace"
  :showUHiveBanner = "showUHiveBanner"
  :postID = "postID"
  >
  </PostBase>
</template>

<script>
import PostBase from '../components2/base/post-base.vue';

export default {
  name: "PostView",
  components:{
    PostBase: PostBase,
  },
  props: {
    postID: {
      type: String,
      required: true,
    },
    isShareSpace: {
      type: Boolean,
      default: false,
    },
    showUHiveBanner: {
      type: Boolean,
      default: false,
    }
  },
};  
</script>